/** student/portfolio — HOOKS. */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { studentPortfolioApi } from './api';
import { studentPortfolioKeys } from './keys';

export function useStudentPortfolio(enabled = true) {
  return useQuery({
    queryKey: studentPortfolioKeys.all(),
    queryFn: () => studentPortfolioApi.fetchMine(),
    enabled,
  });
}

export function useSetBio() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (bio: string) => studentPortfolioApi.setBio(bio),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: studentPortfolioKeys.all() });
    },
  });
}
